import { useContext, React, useEffect, useState } from "react";
import Main from "./Main";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import SignUp from "./Authentication/SignUp";
import SignIn from "./Authentication/SignIn";
import ResetPassword from "./Authentication/ResetPassword";
import ForgotPassword from "./Authentication/ForgotPassword";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthContextProvider, UserAuth, InterestContext } from "./Context";
import ProductDetails from "./ProductDetails";
import Header from "./Header/Header";
import Header3 from "./Header/Header3";
import BrandsPage from "./SideNav/BrandsPage";
import UserSettings from "./Authentication/UserSettings";
import ProfilePage from "./UserProfile/ProfilePage";
import RegionBrands from "./UserProfile/RegionBrands";
import StaticPages from "./StaticPages/StaticPages";
import TermsOfService from "./StaticPages/TermsOfService";
import GenderBdInput from "./Authentication/GenderBdInput";
import ModalManager from "./Modals/ModalManager";
import PrivacyPolicy from "./StaticPages/PrivacyPolicy";
import MoreQuestions from "./Authentication/MoreQuestions";
import VerifyEmail from "./Authentication/VerifyEmail";
import ContactUs from "./ContactUs";
import PhoneAuth from "./PhoneAuth";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "./FirebaseConfig";
import usefavStore from "./StatesStore/FavStore";
import useSaveStore from "./StatesStore/SaveStore";
import useLikeStore from "./StatesStore/LikeStore";
import ConvertLogostoUrl from "./lib/convertLogostoUrls";
import SignInInput from "./Authentication/SignInInput";
import usePointsStore from "./StatesStore/PointsTable";
import Chat from "./Chat/Chat";
import BrandPostForm from "./Brands/CreateBrandPost";
import BrandHandlerSettings from "./Brands/BrandHandlerSettings";
import TransferLogoUrlsComponent from "./lib/convertLogostoUrls";
import SecondHeader from "./Header/SecondHeader";
import SideNavUserProfile from "./SideNav/SideNavUserProfile";
import UserSettings2 from "./Authentication/UserSettings2";
import UnderAgeWarning from "./Notifications/UnderAgeWarning";
import IncomepleteProfile from "./Notifications/IncompleteProfile";
import UserSettings3 from "./Authentication/UserSettings3";
import SearchHeader from "./Header/SearchHeader";
import io from "socket.io-client";
import useSocketStore from "./StatesStore/Socket";
import LandingPage from "./LandingPage/LandingPage";
import TestingStep1 from "./LandingPage/TestingStep1";
import LandingPage2 from "./LandingPage2/LandingPage2";
import SecondHeader2 from "./Header/SecondHeader2";
import SecondHeader3 from "./Header/SecondHeader3";
import useSearchBarOpenState from "./StatesStore/SearchBarOpen";
import useChatOpen from "./StatesStore/ChatOpen";
import ChatFilter from "./Chat/ChatFilter";
import ProfilePage2 from "./UserProfile/ProfilePage2";
import Landing from "./Landing/Landing";
import WebFont from "webfontloader";
import CompleteProfile from "./Authentication/CompleteProfile/CompleteProfile";
import useActiveBrandsStore from "./StatesStore/ActiveBrands";
import ProfileDrawer from "./ProfileDrawer";
import NotificationSideBar from "./Notifications/AllNotifications/NotificationSideBar";
import SimilarProducts from "./Products/SimilarProducts";
import MobileScreenHeader from "./Header/MobileScreenHeader";
import BrandsPage2 from "./SideNav/BrandsPage2";
import Sidebar from "./Sidebar/Sidebar";
import GoogleForm2 from "./GoogleForm2";
import { usePostHog } from "posthog-js/react";
import GoogleFormSubmission from "./FeedbackForm/GoogleFormSubmission";
import useUserDataStore from "./StatesStore/UserData";

const queryClient = new QueryClient();

function App() {
  const { user, underAge, parentalConsent, incompleteProfile } = UserAuth(); // use the UserAuth hook to
  // const { user } = UserAuth(); // Ensure that UserAuth is used after AuthContextProvider
  const { interestedProducts, setInterestedProducts } = useContext(
    InterestContext
  );
  const location = useLocation();
  const addSave = useSaveStore((state) => state.addSave);
  const savedProducts = useSaveStore((state) => state.savedProducts);
  const addLike = useLikeStore((state) => state.addLike);
  const likedProducts = useLikeStore((state) => state.likedProducts);
  const setPointsTable = usePointsStore((state) => state.setPointsTable);
  const navigate = useNavigate();
  const setSocket = useSocketStore((state) => state.setSocket);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const { setIsSearchBarOpen } = useSearchBarOpenState();
  const { isChatOpen } = useChatOpen();
  const setUserData = useUserDataStore((state) => state.setUserData);
  const posthog = usePostHog();

  useEffect(() => {
    if (user && user?.emailVerified && location.pathname === "/landing") {
      navigate("/");
    }
  }, [location]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //for Post Hog
  useEffect(() => {
    if (user?.providerData?.[0]) {
      posthog?.identify(user?.providerData?.[0]?.uid, {
        email: user?.providerData?.[0]?.email,
      });
    }
  }, [posthog, user?.providerData?.[0]]);

  useEffect(() => {
    const fetchUserData = async (uid) => {
      if (!uid) return; // early return if no uid

      try {
        const userDocRef = doc(db, "users", uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();

          setUserData(userData);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    if (user?.uid) {
      fetchUserData(user.uid);
    }
  }, [user?.uid]);

  // useEffect(() => {
  //   const fetchSavedData = async () => {
  //     if (!user) return;
  //     const savedPostRef = collection(db, "users", user?.uid, "saved");
  //     const savedPostData = await getDocs(savedPostRef);
  //     savedPostData.docs.map((post) => {
  //       addSave(post?.id);
  //     });
  //   };
  //   fetchSavedData();
  // }, [user]);
  // useEffect(() => {
  //   const fetchLikesData = async () => {
  //     if (!user) return;
  //     const likePostRef = collection(db, "users", user?.uid, "likeList");
  //     const likePostData = await getDocs(likePostRef);
  //     likePostData.docs.map((post) => {
  //       addLike(post?.id);
  //     });
  //   };
  //   fetchLikesData();
  // }, [user]);
  // useEffect(() => {
  //   if (!savedProducts) return;
  //   console.log("Save", savedProducts);
  //   console.log("REACT_API", process.env.REACT_APP_API);
  // }, [savedProducts]);
  // useEffect(() => {
  //   if (!likedProducts) return;
  //   console.log("Liked", likedProducts);
  // }, [likedProducts]);
  const setActiveBrands = useActiveBrandsStore(
    (state) => state.setActiveBrands
  );

  useEffect(() => {
    const getBrands = async () => {
      const qry = query(collection(db, "brands"), where("status", ">", 0));

      const data = await getDocs(qry);

      setActiveBrands(data.docs.map((doc) => doc.data()));
    };

    getBrands();
  }, []);
  useEffect(() => {
    const fetchPointsTable = async () => {
      try {
        // Create a query to get the most recent document based on timestamp
        const q = query(
          collection(db, "poistsSystem"),
          orderBy("timestamp", "desc"), // Order by timestamp in descending order
          limit(1) // Limit the result to 1 document
        );

        const querySnapshot = await getDocs(q);

        // Fetch the first document
        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];
          setPointsTable({ id: doc.id, ...doc.data() });
        }
      } catch (error) {
        console.error("Error fetching points table:", error);
      }
    };

    fetchPointsTable();
  }, []);
  // Redirect to SignIn if the user is null and tries to access /settings
  useEffect(() => {
    if (
      !user &&
      location.pathname !== "/SignIn" &&
      location.pathname !== "/SignUp" &&
      location.pathname !== "/Reset" &&
      location.pathname !== "/ForgotPassword" &&
      location.pathname !== "/SignInInput" &&
      location.pathname !== "/staticPages/termsAndConditions" &&
      location.pathname !== "/staticPages/privacyPolicy" &&
      location.pathname !== "/VerifyEmail" &&
      location.pathname !== "/landing" &&
      !location.pathname.includes("/shoppingList/")
    ) {
      console.log("Redirecting to landing");
      navigate("/landing");
    }
  }, [location]);
  useEffect(() => {
    WebFont.load({
      google: {
        families: ["Playfair Display", "Open Sans"],
      },
    });
  }, []);
  return (
    <AuthContextProvider>
      <>
        <QueryClientProvider client={queryClient}>
          <ToastContainer />
          <ModalManager />
          {location.pathname === "/SignUp" ||
          location.pathname === "/SignIn" ||
          location.pathname === "/SignInInput" ||
          location.pathname === "/CompleteProfile" ||
          location.pathname === "/TempSignInInput" ||
          location.pathname === "/Reset" ||
          location.pathname === "/UserInfo" ||
          location.pathname === "/VerifyEmail" ||
          location.pathname === "/PhoneAuth" ||
          location.pathname === "/ForgotPassword" ? (
            <div className="bg-image object-fit-scale bgImg bgImgUrl">
              <Routes>
                <Route path="/SignIn" element={<SignIn />} />
                {/* <Route path="/SignInInput" element={<GenderBdInput />} /> */}
                <Route path="/SignInInput" element={<SignInInput />} />
                <Route path="/CompleteProfile" element={<CompleteProfile />} />
                <Route path="/SignUp" element={<SignUp />} />
                <Route path="/Reset" element={<ResetPassword />} />
                <Route path="/ForgotPassword" element={<ForgotPassword />} />
                {/* <Route path="/UserInfo" element={<MoreQuestions />} /> */}
                <Route path="/VerifyEmail" element={<VerifyEmail />} />
                <Route path="/PhoneAuth" element={<PhoneAuth />} />
              </Routes>
            </div>
          ) : (
            <>
              {((user && !isChatOpen) || (!user && !isSmallScreen)) && (
                <header className="navbar-light sticky-top header-static bg-transparent h-100">
                  <InterestContext.Provider
                    value={{ interestedProducts, setInterestedProducts }}
                  >
                    {isSmallScreen ? <Header /> : <Header3 />}
                  </InterestContext.Provider>
                </header>
              )}

              <main
                id="main"
                onClick={() => {
                  setIsSearchBarOpen(false);
                }}
                style={{
                  marginTop: user
                    ? isSmallScreen
                      ? location.pathname.includes("chat")
                        ? isChatOpen
                          ? "0"
                          : "0px"
                        : "48px"
                      : "0"
                    : location.pathname === "/landing" ||
                      location.pathname === "/landing2"
                    ? ""
                    : "3rem",
                  height: "auto",
                }}
              >
                <div className={``} id="App">
                  {/* <style jsx>
                    {`
                      ::-webkit-scrollbar {
                        width: 8px;
                      }

                      ::-webkit-scrollbar-thumb {
                        background-color: #888;
                        border-radius: 10px;
                      }

                      ::-webkit-scrollbar-thumb:hover {
                        background-color: #555;
                      }
                    `}
                  </style> */}
                  {user &&
                  !location.pathname.includes("/userProfile") &&
                  underAge &&
                  !parentalConsent ? (
                    <div className="d-flex mb-2 mx-1 ms-2">
                      {/* <div className="col-lg-20"></div> */}
                      <UnderAgeWarning user={user} />
                      {/* <div className="col-lg-20"></div> */}
                    </div>
                  ) : null}
                  {user &&
                    !location.pathname.includes("/userProfile") &&
                    incompleteProfile && (
                      <div className="mb-2 ms-1">
                        {/* <div className="col-lg-20"></div> */}
                        <IncomepleteProfile user={user} />
                        {/* <div className="col-lg-20"></div> */}
                      </div>
                    )}
                  {/* <div className="row g-5"> */}
                  <div
                    className={`row mx-0 mb-md-0`}
                    style={{ marginBottom: "60px" }}
                  >
                    {/* {location.pathname.includes("/userProfile") && (
                      // <SideNavUserProfile />
                      <div className="col-lg-20"></div>
                    )} */}
                    {!location.pathname.includes("/chat") && user && (
                      <div className="d-none d-md-block col-md-20 px-0">
                        <Sidebar />
                      </div>
                    )}
                    <div
                      className={`px-0 ${!location.pathname.includes("/chat") &&
                        "col-12 col-md-80 col-lg-80 mx-auto"}`}
                      style={{
                        maxWidth:
                          !location.pathname.includes("/chat") && "1188px",
                      }}
                    >
                      <Routes>
                        <Route
                          path="/PostCreate/:id"
                          element={<BrandPostForm />}
                        />
                        {/* <Route
                        path="/ProductDetails/:id"
                        element={<ProductDetails />}
                      /> */}
                        <Route
                          path="/ProductDetails/:id"
                          element={<SimilarProducts />}
                        />
                        <Route path="/brands" element={<BrandsPage2 />} />
                        <Route
                          path="/feedbackForm2"
                          element={<GoogleForm2 />}
                        />
                        <Route
                          path="/feedbackForm"
                          element={<GoogleFormSubmission />}
                        />
                        <Route path="/settings/*" element={<UserSettings2 />} />
                        <Route
                          path="/testSettings/*"
                          element={<UserSettings3 />}
                        />
                        <Route
                          path="/settings/brandHandler"
                          element={<UserSettings tab={"brandHandler"} />}
                        />
                        {/* <Route
                        path="/userProfile2/:uid/*"
                        element={<ProfilePage />}
                      /> */}
                        <Route
                          path="/userProfile/:uid/*"
                          element={<ProfilePage />}
                        />
                        {/* <Route path="/chat1" element={<Chat />} /> */}
                        <Route
                          path="/staticPages/*"
                          element={<StaticPages />}
                        />
                        <Route path="/*" element={<Main />} />
                        <Route
                          path="/testingStep1"
                          element={<TestingStep1 />}
                        />
                        {!user && (
                          <Route path="/landing" element={<Landing />} />
                        )}
                      </Routes>
                    </div>
                    <ProfileDrawer />
                    <NotificationSideBar />
                    {/* {location.pathname.includes("/userProfile") && (
                      // <SideNavUserProfile />
                      <div className="col-lg-20"></div>
                    )} */}
                  </div>
                </div>
              </main>
              {user && !isChatOpen && <MobileScreenHeader />}
            </>
          )}
        </QueryClientProvider>
      </>
    </AuthContextProvider>
  );
}
export default App;
